export enum ModuleEnum {
  CONTRACT = 'contract',
  SIMULATION = 'simulation',
  DEMAND = 'demand',
  INVOICE = 'invoice',
  WALLET = 'wallet',
}
